<template>
  <div class="">
    <div class="mapStyle" id="map">
    </div>
    <div id="mapHeaderIcon">
      <img src="assets/ASCP-New-Logo.svg" class="mapIcon" height="50px"/>
    </div>
    <MapComponent id="legend" inputClass="overlay-tr">
      <template slot="header">
        <h6>Legend</h6>
      </template>
      <template slot="body">
        <table class="table table-sm table-borderless m-0">
          <tbody>
            <tr  v-for="(item,index) in Object.keys(pointColor)" class="pt-0 pb-0" @click="rowClicked(item)" :id="item+'Label'">
              <td>
                <svg height="12" width="12">
                  <circle cx="6" cy="6" r="5" stroke="black" stroke-width="0.5" :fill="pointColor[item]"/>
                </svg>
              </td>
              <td >{{item}}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </MapComponent>
    <div id="popup">
      <!-- <a href="#" id="popup-closer" class="ol-popup-closer"></a> -->
      <dl id="popup-content" class="col-12">
        <template v-if="popupData.project_name">
          <dt>Name</dt>
          <dd>{{popupData.project_name}}</dd>
        </template>
        <template v-if="popupData.contractor">
          <dt>Contractor</dt>
          <dd>{{popupData.contractor}}</dd>
        </template>
        <template v-if="popupData.pavement_type">
          <dt>Pavement</dt>
          <dd>{{popupData.pavement_type}}</dd>
        </template>
        <template v-if="popupData.state">
          <dt>State</dt>
          <dd>{{popupData.state}}</dd>
        </template>
        <template v-if="popupData.suburb">
          <dt>Suburb</dt>
          <dd>{{popupData.suburb}}</dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
require('mapbox.js')

import 'mapbox-gl/src/css/mapbox-gl.css'
import {mapBoxToken} from '../../../token-config.js'
import MapComponent from './../PavementBody/MapComponent.vue'
// import Map from 'mapbox-gl/src/ui/map.js'
// import * as styles from '@mapbox-gl/src/style'
export default {
  name: "MapBoxMap",
  components: {
    MapComponent
  },
  props: {
    generateMapFlag: Boolean,
    geoJsonData: Object
  },
  data() {
    return {
      map: {},
      popup: {},
      legendControl: {},
      popupData: {
        contractor: "",
        dc: "",
        pavement_type: "",
        postcode: "",
        project_name: "",
        state: "",
        suburb: "",
        year_paved: ""
      },
      pointColor:{
        PCP: "#2ecc71",
        CRCP: "#9b59b6",
        JRCP: "#3498db",
        NONE: "#e74c3c"
      }

    }
  },
  mounted() {
    // will be fetched using a free created account
    const current = this
    var unclusteredPointTypes = [
      'unclustered-point_PCP',
      'unclustered-point_JRCP',
      'unclustered-point_CRCP',
      'unclustered-point_NONE'
    ]
    mapboxgl.accessToken = mapBoxToken
    current.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/dark-v9?optimize=true', // stylesheet location
      center: [151.2093, -33.8688], // starting position [lng, lat]
      minZoom: 4,
      maxZoom: 14,
      zoom: 6 // starting zoom
    });
    current.popup = new mapboxgl.Popup().setDOMContent(document.getElementById("popup"))
    var legend = document.getElementById('legend');
    var navigationControl = new mapboxgl.NavigationControl({});
    var fullScreenControl = new mapboxgl.FullscreenControl({});
    var legendControl = {
      onAdd(map) {
        this._map = map;
        this._container = document.getElementById('legend');
        this._container.className = 'legendControl mapboxgl-ctrl card';
        return this._container;
      },
      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    var iconHeader = {
      onAdd(map) {
        this._map = map;
        this._container = document.getElementById('mapHeaderIcon');
        this._container.className = 'mapboxgl-ctrl mapIcon';
        return this._container;
      },
      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    current.map.addControl(legendControl,'top-right')
    current.map.addControl(iconHeader, 'top-left')
    current.map.addControl(navigationControl, 'top-left')
    current.map.addControl(fullScreenControl, 'top-left')

    unclusteredPointTypes.forEach(type=>{
      current.map.on('mouseenter', type, function () {
        current.map.getCanvas().style.cursor = 'pointer';
      });
      current.map.on('mouseleave', type, function () {
        current.map.getCanvas().style.cursor = '';

      });

      current.map.on('click', type, function(event){
        event.preventDefault();
        var coordinates = event.features[0].geometry.coordinates.slice()
        var properties = event.features[0].properties
        Object.keys(properties).forEach((item)=>{
          if (properties[item] != "null") {
            current.popupData[item] = properties[item]
          }
          else {
            current.popupData[item] = ""
          }
        })
        current.popup.setLngLat(coordinates).addTo(current.map)
      })
    })
    current.renderData();
  },
  watch: {
    // geoJsonData: function () {
    //   const current = this;
    //   console.log("went here 3");
    //   console.log(current.generateMapFlag);
    //   console.log(current.geoJsonData);
    //   var layerTypes = ["PCP","JRCP","CRCP","NONE"];
    //   current.map.on("load", ()=> {
    //     layerTypes.forEach(layerType=>{
    //       if (typeof this.geoJsonData[layerType] != "undefined" && typeof this.geoJsonData[layerType].type != "undefined") {
    //         // data hack, better to provide a backend solution
    //         this.geoJsonData[layerType].features.forEach((feature, featureIndex)=>{
    //           feature.geometry.coordinates.forEach((coordinate,index)=>{
    //             let value = 0.002 * (Math.random()-0.5*(Math.random()+0.5*Math.random()))
    //             feature.geometry.coordinates[index] += value
    //           })
    //         })
    //         // data hack end
    //         this.map.addSource(layerType, {
    //           type: "geojson",
    //           data: this.geoJsonData[layerType],
    //           cluster: true,
    //           clusterMaxZoom: 12,
    //           clusterRadius: 25
    //         })
    //
    //         this.map.addLayer({
    //           id: "clusters_"+layerType,
    //           type: "circle",
    //           source: layerType,
    //           filter: ["has", "point_count"],
    //           paint: {
    //             "circle-color": [
    //               "step",
    //               ["get", "point_count"],
    //               this.pointColor[layerType],
    //               5,
    //               this.pointColor[layerType],
    //               10,
    //               this.pointColor[layerType]
    //             ],
    //             "circle-radius": [
    //               "step",
    //               ["get", "point_count"],
    //               12,
    //               5,
    //               20,
    //               10,
    //               25
    //             ],
    //             "circle-opacity": 0.6
    //           }
    //         });
    //
    //         this.map.addLayer({
    //           id: "cluster-count_"+layerType,
    //           type: "symbol",
    //           source: layerType,
    //           filter: ["has", "point_count"],
    //           layout: {
    //             "text-field": "{point_count_abbreviated}",
    //             "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    //             "text-size": 12,
    //             "text-allow-overlap": true
    //           },
    //           paint: {
    //             "text-color": "#FFFFFF"
    //           }
    //         });
    //
    //         this.map.addLayer({
    //           id: "unclustered-point_"+layerType,
    //           type: "circle",
    //           source: layerType,
    //           filter: ["!", ["has", "point_count"]],
    //           paint: {
    //             "circle-color": this.pointColor[layerType],
    //             "circle-radius": 4,
    //             "circle-stroke-width": 1,
    //             "circle-stroke-color": "#fff",
    //           }
    //         });
    //       }
    //     })
    //   })
    // },

  },
  methods: {
    rowClicked: function(data) {
      const current = this
      let label = document.getElementById(data+"Label")
      label.classList.toggle("strikeThrough")
      var clusterId = "clusters_"+data
      var clusterCountId = "cluster-count_"+data
      var unclusteredPointId = "unclustered-point_"+data
      var isVisible = label.classList.contains("strikeThrough")?false:true
      current.map.setLayoutProperty(clusterId, 'visibility', isVisible?'visible':'none')
      current.map.setLayoutProperty(clusterCountId, 'visibility', isVisible?'visible':'none')
      current.map.setLayoutProperty(unclusteredPointId, 'visibility', isVisible?'visible':'none')
    },
    renderData: function () {
      const current = this;
      var layerTypes = ["PCP","JRCP","CRCP","NONE"];
      current.map.on("load", ()=> {
        layerTypes.forEach(layerType=>{
          if (typeof this.geoJsonData[layerType] != "undefined" && typeof this.geoJsonData[layerType].type != "undefined") {
            // data hack, better to provide a backend solution
            this.geoJsonData[layerType].features.forEach((feature, featureIndex)=>{
              feature.geometry.coordinates.forEach((coordinate,index)=>{
                let value = 0.002 * (Math.random()-0.5*(Math.random()+0.5*Math.random()))
                feature.geometry.coordinates[index] += value
              })
            })
            // data hack end
            this.map.addSource(layerType, {
              type: "geojson",
              data: this.geoJsonData[layerType],
              cluster: true,
              clusterMaxZoom: 12,
              clusterRadius: 25
            })

            this.map.addLayer({
              id: "clusters_"+layerType,
              type: "circle",
              source: layerType,
              filter: ["has", "point_count"],
              paint: {
                "circle-color": [
                  "step",
                  ["get", "point_count"],
                  this.pointColor[layerType],
                  5,
                  this.pointColor[layerType],
                  10,
                  this.pointColor[layerType]
                ],
                "circle-radius": [
                  "step",
                  ["get", "point_count"],
                  12,
                  5,
                  20,
                  10,
                  25
                ],
                "circle-opacity": 0.6
              }
            });

            this.map.addLayer({
              id: "cluster-count_"+layerType,
              type: "symbol",
              source: layerType,
              filter: ["has", "point_count"],
              layout: {
                "text-field": "{point_count_abbreviated}",
                "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                "text-size": 12,
                "text-allow-overlap": true
              },
              paint: {
                "text-color": "#FFFFFF"
              }
            });

            this.map.addLayer({
              id: "unclustered-point_"+layerType,
              type: "circle",
              source: layerType,
              filter: ["!", ["has", "point_count"]],
              paint: {
                "circle-color": this.pointColor[layerType],
                "circle-radius": 4,
                "circle-stroke-width": 1,
                "circle-stroke-color": "#fff",
              }
            });
          }
        })
      })
    },

  }
}
</script>

<style lang="css">
  .mapStyle {
    position:absolute;
    top:0;
    bottom:0;
    width:100%;
  }
  .legendControl {
    font-family: 'Montserrat';
  }
  .mapIcon {
    position: absolute;
    top: 0.5px;
    left: 1.75em;
  }
  .strikeThrough {
    text-decoration: line-through;
    text-emphasis-style:
  }
  .mapboxgl-popup-content {
    font-family: 'Montserrat';
  }
</style>
